import Vue from 'vue';
import Component from 'vue-class-component';
import { TOOLS_STORE } from '@/tools/store/tools.store';
import Organization from '@/tools/models/organization.model';
import EdCreateStaffComponent from '@/tools/components/ed-staff-admin/ed-create-staff/ed-create-staff.component.vue'
import EdListStaffComponent from '@/tools/components/ed-staff-admin/ed-list-staff/ed-list-staff.component.vue';

@Component({
  name: 'staff-admin',
  components: {
    EdCreateStaff: EdCreateStaffComponent,
    EdListStaff: EdListStaffComponent
  }
})
export default class StaffAdminView extends Vue {

  /* Data */
  public organization: Organization = new Organization;
  public openCreateStaff: boolean = false;

  /* Methods */
  createStaff() {
    this.openCreateStaff = !this.openCreateStaff;
  }

  closeCreateStaff() {
    this.openCreateStaff = false;
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on('closeCreateStaff', this.closeCreateStaff);
    this.$store.dispatch(`${TOOLS_STORE.ACTIONS.GET_INSTITUTION_INFO}`).then(() => {
      this.organization = this.$store.state.ToolsStore.institutionInfo[0];
    });
  }

  beforeDestroy() {
    this.$edEventBus.$off('closeCreateStaff', this.closeCreateStaff);
  }
}
